import type { Option } from 'element-plus/es/components/select-v2/src/select.types'
import { IPV4Type, IPV6Type, IPIPV4Type, IPIPV6Type } from './constant'
import { FormSize } from '@/enums/appEnums'

export const baseCodeType = [
    'unit_type', //'单位分类代码'
    'nature', //'单位性质代码'
    'address', //'区域代码'
    'question', //'意见反馈问题分类代码'
    'bureau', //'管局信息分类代码(服务器放置地)'
    'industry', //'行业分类代码'
    'alevel', //'行政级别代码'
    'card_type', //'证件类型代码'
    'operate', //'网站经营内容类型代码（专项审批）'
    'web_server', //'网站服务内容类型代码'
    'interface', //'网站接入方式代码'
    'off', //'注销理由代码'
    'notfd', //'未备案独立域名处理代码'
    'verify', //'核实意见代码'
    'domain_type', //'域名类型代码'
    'file_format', //'附件文件格式代码'
    'file_use_to', //'附件用途代码'
    'lang', //'网站语言类别代码'
    'socket', //'及时通讯代码'
    'app_server_type', //'应用服务类型代码'
    'resources', //'资源类型代码'
    'app_xkserver_type', //'APP/小程序/快应用服务类型代码表'
    'skd_server_cs', //'SDK服务厂商代码表'
    'sdk_server_type', //'SDK服务类型代码表'
    'ip_check_attr_type', //IP属性核查类型代码表
    'ip_check_error_type', //IP核查错误类型代码表
    'ip_check_feedback_type', //IP核查反馈类型代码表
    'ip_app_service_type' //IP应用服务类型代码表
]
// 枚举数据
export const enumType = [
    //  备案状态
    'filings_status',
    // 备案来源类型
    'filings_source_type',
    // 核实方法类型
    'verify_type',
    // 运行平台类型
    'app_platform_type'
]
// 默认表单尺寸
export const defaultFormSize = FormSize.SMALL

// 备案要求
interface Requset {
    label: number
    value: {
        nature: string
        organizationType: {
            title: string
            list: Array<string>
        }
    }
}
export const requestedType: Array<Requset> = [
    {
        // 北京
        label: 110000,
        value: {
            // 主办单位性质
            nature: '',
            // 主办单位有效证件类型
            organizationType: {
                title: '北京市特殊要求',
                list: [
                    '企业必须选择工商营业执照；',
                    '民办非企业单位必须选择组织机构代码证；',
                    '中国公民必须选择身份证;'
                ]
            }
        }
    },

    {
        // 天津
        label: 120000,
        value: {
            // 主办单位性质
            nature: '个体工商户请选择企业。',
            // 主办单位有效证件类型
            organizationType: {
                title: '天津市特殊要求：',
                list: [
                    '企业必须选择工商营业执照；',
                    '事业单位选择事业法人证书，若暂未更换“三证合一”证件的，选择组织机构代码证，同时在备注中说明相关情况；',
                    '政府机关、社会团体必须选择组织机构代码证;'
                ]
            }
        }
    },
    {
        // 河北
        label: 130000,
        value: {
            // 主办单位性质
            nature: '个体工商户有字号的请选择企业；没有字号的请选择个人，并在备注里说明“个体工商户无工商字号”。',
            // 主办单位有效证件类型
            organizationType: {
                title: '河北省特殊要求：',
                list: ['外籍人士证件不能进行个人备案;']
            }
        }
    },

    {
        // 山西
        label: 140000,
        value: {
            // 主办单位性质
            nature: '个体工商户请选择企业；如无字号需将营业执照字号等信息到当地工商局变更完整后备案。',
            // 主办单位有效证件类型
            organizationType: {
                title: '山西省特殊要求：',
                list: ['非山西本省身份证不能进行个人备案;']
            }
        }
    },
    {
        // 内蒙古自治区
        label: 150000,
        value: {
            // 主办单位性质
            nature: '个体工商户有字号及公章请选择企业；无字号及公章请选择个人，需备注“个体经营”。',
            // 主办单位有效证件类型
            organizationType: {
                title: '内蒙古自治区特殊要求：',
                list: ['临时身份证不可用于备案;']
            }
        }
    },

    {
        // 吉林省
        label: 220000,
        value: {
            // 主办单位性质
            nature: '',
            // 主办单位有效证件类型
            organizationType: {
                title: '吉林省特殊要求：',
                list: ['企业必须选择工商营业执照;']
            }
        }
    },

    {
        // 黑龙江省
        label: 230000,
        value: {
            // 主办单位性质
            nature: '',
            // 主办单位有效证件类型
            organizationType: {
                title: '黑龙江省特殊要求：',
                list: [
                    '企业已更换“统一社会信用代码证”的，必须使用该证件备案，没有更换的企业，使用营业执照；',
                    '律师事务所提供“组织机构代码证”或“律师事务所执业许可证”备案，其他单位必须选择组织机构代码证；',
                    '个人备案：中国公民必须选择身份证，非黑龙江本省身份证不能备案；'
                ]
            }
        }
    },
    {
        // 上海市
        label: 310000,
        value: {
            // 主办单位性质
            nature: '个人性质备案不能开办企业、论坛、教育、医疗、游戏类网站，否则上海市通信管理局会将您的网站备案号进行注销，导致您的网站无法访问。        ',
            // 主办单位有效证件类型
            organizationType: {
                title: '上海市特殊要求：',
                list: [
                    '企业必须选择工商营业执照;',
                    '主办单位性质为个人的，不可使用临时身份证备案;',
                    '主办单位性质为个人的，港澳公民可使用港澳通行证备案;'
                ]
            }
        }
    },
    {
        // 江苏省
        label: 320000,
        value: {
            // 主办单位性质
            nature: '个体工商户请选择企业；如无字号需将营业执照字号等信息到当地工商局变更完整后再进行备案。',
            // 主办单位有效证件类型
            organizationType: {
                title: '',
                list: []
            }
        }
    },

    {
        // 浙江省
        label: 330000,
        value: {
            // 主办单位性质
            nature: '个体工商户请选择企业；相关政策法规：依据《非经营性互联网信息服务备案管理办法》第二十三条规定，如备案信息不真实，将关闭网站并注销备案。若您的备案信息发生变更，请您尽快将备案信息进行变更，感谢您的配合，谢谢！',
            // 主办单位有效证件类型
            organizationType: {
                title: '',
                list: []
            }
        }
    },
    {
        // 安徽省
        label: 340000,
        value: {
            // 主办单位性质
            nature: '个体工商户请选择企业，如无公章需在备注中说明“个体工商户无公章”。',
            // 主办单位有效证件类型
            organizationType: {
                title: '',
                list: []
            }
        }
    },
    {
        // 福建省
        label: 350000,
        value: {
            // 主办单位性质
            nature: '会计师事务所请选择企业；个体工商户有字号及公章的请选择企业，如无字号及公章请选择个人。',
            // 主办单位有效证件类型
            organizationType: {
                title: '',
                list: []
            }
        }
    },
    {
        // 江西省
        label: 360000,
        value: {
            // 主办单位性质
            nature: '',
            // 主办单位有效证件类型
            organizationType: {
                title: '',
                list: []
            }
        }
    },
    {
        // 山东省
        label: 370000,
        value: {
            // 主办单位性质
            nature: '个体工商户请选择企业。',
            // 主办单位有效证件类型
            organizationType: {
                title: '山东省特殊要求：',
                list: [
                    '企业必须选择工商营业执照；',
                    '其他单位必须选择组织机构代码证。'
                ]
            }
        }
    },
    {
        // 河南省
        label: 410000,
        value: {
            // 主办单位性质
            nature: '个体工商户请选择企业。',
            // 主办单位有效证件类型
            organizationType: {
                title: '河南省特殊要求：',
                list: [
                    '企业必须选择工商营业执照；',
                    '其他单位必须选择组织机构代码证；',
                    '个人备案：非河南本省身份证不能备案。'
                ]
            }
        }
    },
    {
        // 湖北省
        label: 420000,
        value: {
            // 主办单位性质
            nature: '个体工商户请选择企业。',
            // 主办单位有效证件类型
            organizationType: {
                title: '湖北省特殊要求：',
                list: ['企业之外的其他单位必须选择组织机构代码证。']
            }
        }
    },
    {
        // 湖南省
        label: 430000,
        value: {
            // 主办单位性质
            nature: '个体工商户有字号的请选择企业，如无公章需在备注中说明“个体工商户无公章”；个体工商户无字号的，请选择个人。',
            // 主办单位有效证件类型
            organizationType: {
                title: '',
                list: []
            }
        }
    },
    {
        // 广东省
        label: 440000,
        value: {
            // 主办单位性质
            nature: '个体工商户有字号的请选择企业，如无公章需备注“个体工商户无公章”；个体工商户没有字号的请选择个人，并在备注里说明“个体工商户无工商字号”，同时注明注册号。',
            // 主办单位有效证件类型
            organizationType: {
                title: '',
                list: []
            }
        }
    },
    {
        // 广西壮族自治区
        label: 450000,
        value: {
            // 主办单位性质
            nature: '',
            // 主办单位有效证件类型
            organizationType: {
                title: '广西壮族自治区特殊要求：',
                list: ['企业必须选择工商营业执照。']
            }
        }
    },
    {
        // 海南省
        label: 460000,
        value: {
            // 主办单位性质
            nature: '个体工商户有字号的请选择企业；没有字号的请选择个人，并在备注里说明“个体工商户无工商字号”。',
            // 主办单位有效证件类型
            organizationType: {
                title: '海南省特殊要求：',
                list: [
                    '企业必须选择工商营业执照；',
                    '其他单位必须选择组织机构代码证；',
                    '中国公民必须用身份证，临时身份证不可用于备案。'
                ]
            }
        }
    },
    {
        // 重庆市
        label: 500000,
        value: {
            // 主办单位性质
            nature: '个体工商户请选择企业，如无公章需备注“个体工商户无公章”。',
            // 主办单位有效证件类型
            organizationType: {
                title: '重庆市特殊要求：',
                list: ['非重庆本地身份证不能进行个人备案。']
            }
        }
    },
    {
        // 四川省
        label: 510000,
        value: {
            // 主办单位性质
            nature: '个体工商户有字号及公章请选择企业；无字号及公章请选择个人，需备注“个体经营”。',
            // 主办单位有效证件类型
            organizationType: {
                title: '',
                list: []
            }
        }
    },
    {
        // 贵州省
        label: 520000,
        value: {
            // 主办单位性质
            nature: '个体工商户有字号的请选择企业；没有字号的请选择个人，并在备注里说明“个体工商户无字号”。',
            // 主办单位有效证件类型
            organizationType: {
                title: '',
                list: []
            }
        }
    },
    {
        // 云南省
        label: 530000,
        value: {
            // 主办单位性质
            nature: '',
            // 主办单位有效证件类型
            organizationType: {
                title: '',
                list: []
            }
        }
    },
    {
        // 西藏自治区
        label: 540000,
        value: {
            // 主办单位性质
            nature: '备案信息需真实有效，网站内容需与备案信息保持一致；个人性质备案不能开办企业、论坛、教育、医疗、游戏类网站；网站内容不能涉及黄、赌、毒及敏感时政类新闻等；如涉及以上内容西藏自治区通信管理局会将您的网站备案号进行注销，导致您的网站无法访问。',
            // 主办单位有效证件类型
            organizationType: {
                title: '西藏自治区个人备案特殊要求',
                list: ['非西藏自治区本地身份证不能备案。']
            }
        }
    },
    {
        // 陕西省
        label: 610000,
        value: {
            // 主办单位性质
            nature: '个体工商户请选择企业；如无字号需将营业执照字号等信息到当地工商局变更完整后备案。',
            // 主办单位有效证件类型
            organizationType: {
                title: '',
                list: []
            }
        }
    },
    {
        // 甘肃省
        label: 620000,
        value: {
            // 主办单位性质
            nature: '',
            // 主办单位有效证件类型
            organizationType: {
                title: '青海省特殊要求：',
                list: [
                    '非青海本省身份证不能进行个人备案；',
                    '企业性质首次备案必须使用企业营业执照。'
                ]
            }
        }
    },
    {
        // 青海省
        label: 630000,
        value: {
            // 主办单位性质
            nature: '青海省特殊要求：',
            // 主办单位有效证件类型
            organizationType: {
                title: '',
                list: [
                    '企业必须选择工商营业执照；',
                    '其他单位必须选择组织机构代码证；',
                    '个人备案：非甘肃本省身份证不能备案。'
                ]
            }
        }
    },
    {
        // 宁夏回族自治区
        label: 640000,
        value: {
            // 主办单位性质
            nature: '个体工商户有字号的请选择企业；没有字号的请选择个人，并在备注里说明“个体工商户”。',
            // 主办单位有效证件类型
            organizationType: {
                title: '宁夏回族自治区特殊要求：',
                list: ['企业必须选择工商营业执照。']
            }
        }
    },
    {
        // 新疆维吾尔自治区
        label: 650000,
        value: {
            // 主办单位性质
            nature: '',
            // 主办单位有效证件类型
            organizationType: {
                title: '新疆维吾尔自治区特殊要求：',
                list: ['非新疆本地身份证不能进行个人备案。']
            }
        }
    },
    {
        // 跨地区
        label: 32,
        value: {
            // 主办单位性质
            nature: '',
            // 主办单位有效证件类型
            organizationType: {
                title: '',
                list: []
            }
        }
    }
]

interface Options {
    value: number | string
    label: string
}

// IP协议(ICP用)
export const ipProtocolType: Array<Options> = [
    {
        label: 'IPV4',
        value: IPV4Type
    },
    {
        label: 'IPV6',
        value: IPV6Type
    }
]

// IP协议(IP用)
export const ipIpProtocolType: Array<Options> = [
    {
        label: 'IPV4',
        value: IPIPV4Type
    },
    {
        label: 'IPV6',
        value: IPIPV6Type
    }
]

// 指令类型
export const instructType: Array<Options> = [
    {
        label: '常规指令',
        value: '1'
    },
    {
        label: '应急指令',
        value: '2'
    },
    {
        label: '恢复指令',
        value: '233'
    }
]

// 处置要求类型
export const askType: Array<Option> = [
    {
        label: '取消接入',
        value: '1'
    },
    {
        label: '停止接入',
        value: '2'
    },
    {
        label: '阻断URL',
        value: '3'
    },
    {
        label: '其他',
        value: '999'
    }
]

// 处置对象类型
export const disposeType: Array<Option> = [
    {
        label: '域名',
        value: 1
    },
    {
        label: 'RUL',
        value: 2
    },
    {
        label: '其他',
        value: 999
    }
]

// 链路类型
export const periodicLineType: Array<Options> = [
    {
        label: '电信',
        value: 1
    },
    {
        label: '联调',
        value: 2
    },
    {
        label: '移动',
        value: 3
    },
    {
        label: '铁通',
        value: 4
    },
    {
        label: '其他',
        value: 9
    }
]

// 管局类型
export const authorityType: Array<Options> = [
    { label: '所有省管局', value: 0 },
    { label: '北京市', value: 110000 },
    { label: '天津市', value: 120000 },
    { label: '河北省', value: 130000 },
    { label: '山西省', value: 140000 },
    { label: '内蒙古自治区', value: 150000 },
    { label: '辽宁省', value: 210000 },
    { label: '吉林省', value: 220000 },
    { label: '黑龙江省', value: 230000 },
    { label: '上海市', value: 310000 },
    { label: '江苏省', value: 320000 },
    { label: '浙江省', value: 330000 },
    { label: '安徽省', value: 340000 },
    { label: '福建省', value: 350000 },
    { label: '江西省', value: 360000 },
    { label: '山东省', value: 370000 },
    { label: '河南省', value: 410000 },
    { label: '湖北省', value: 420000 },
    { label: '湖南省', value: 430000 },
    { label: '广东省', value: 440000 },
    { label: '广西壮族自治区', value: 450000 },
    { label: '海南省', value: 460000 },
    { label: '重庆市', value: 500000 },
    { label: '四川省', value: 510000 },
    { label: '贵州省', value: 520000 },
    { label: '云南省', value: 530000 },
    { label: '西藏自治区', value: 540000 },
    { label: '陕西省', value: 610000 },
    { label: '甘肃省', value: 620000 },
    { label: '青海省', value: 630000 },
    { label: '宁夏回族自治区', value: 640000 },
    { label: '新疆维吾尔自治区', value: 650000 },
    { label: '跨地区', value: 990000 }
]

// 单位所属分类
export const unitClassType: Array<Options> = [
    { label: '电信业务经营者', value: 11 },
    { label: '公益性互联网络单位', value: 12 },
    { label: '其他', value: 13 }
]

// 单位行业分类
export const unitIndustryClassType: Array<Options> = [
    { value: 1, label: '农、林、牧、渔业' },
    { value: 2, label: '采矿业' },
    { value: 3, label: '制造业' },
    { value: 4, label: '电力、燃气及水的生产和供应业' },
    { value: 5, label: '建筑业' },
    { value: 6, label: '交通运输、仓储和邮政业' },
    { value: 7, label: '信息传输、计算机服务和软件业' },
    { value: 8, label: '批发和零售业' },
    { value: 9, label: '住宿和餐饮业' },
    { value: 10, label: '金融业' },
    { value: 11, label: '房地产业' },
    { value: 12, label: '租赁和商务服务业' },
    { value: 13, label: '科学研究、技术服务和地质勘查业' },
    { value: 14, label: '水利、环境和公共设施管理业' },
    { value: 15, label: '居民服务和其他服务业' },
    { value: 16, label: '教育' },
    { value: 17, label: '卫生、社会保障和社会福利业' },
    { value: 18, label: '文化、体育和娱乐业' },
    { value: 19, label: '公共管理与社会组织' },
    { value: 20, label: '国际组织' }
]

// 核查状态
export const examineStatusType: Array<Options> = [
    { label: '全部', value: 0 },
    { label: '核查通过', value: 1 },
    { label: '核查未通过', value: 2 }
]

// 使用、分配方式
export const useAllocationType: Array<Options> = [
    { label: '分配且使用', value: 1 },
    { label: '再次分配', value: 2 },
    { label: '自用', value: 3 },
    { label: '预留', value: 4 }
]

// 使用方式
export const usageModeType: Array<Options> = [
    { label: '静态', value: 1 },
    { label: '动态', value: 2 },
    { label: '未知', value: 3 }
]

// 是否用于跳转服务器
export const useSkipServerType: Array<Options> = [
    { label: '否', value: 0 },
    { label: '是', value: 1 }
]

// 服务类型
export const serverType: Array<Options> = [
    { label: '企事业单位专线接入', value: 1 },
    { label: '个人专线接入', value: 2 },
    { label: '固定宽带接入', value: 3 },
    { label: '移动网接入', value: 4 },
    { label: '网络设备', value: 5 },
    { label: '网站专线接入', value: 6 },
    { label: 'IDC服务类', value: 7 },
    { label: '物联网', value: 8 },
    { label: '核心网', value: 9 },
    { label: '骨干网', value: 10 },
    { label: '城域网', value: 11 },
    { label: '接入网', value: 12 },
    { label: '工控网', value: 13 },
    { label: '移动网', value: 14 },
    { label: '用户驻地网', value: 15 },
    { label: '其他网络节点', value: 16 },
    { label: '运营商自用接入', value: 17 },
    { label: '其他接入方式', value: 18 },
    { label: 'CDN', value: 19 },
    { label: 'VPN', value: 20 },
    { label: '安全防护', value: 21 },
    { label: '运营商业务自用', value: 22 },
    { label: '其他业务服务', value: 23 },
    { label: '云服务', value: 24 },
    { label: '权威解析', value: 25 },
    { label: '递归解析', value: 26 },
    { label: '其他应用服务', value: 27 },
    { label: '政务生产类', value: 28 },
    { label: '生活消费类', value: 29 },
    { label: '其他类', value: 30 }
]

// 核实操作
export const verifyOperation: Array<Options> = [
    {
        label: '核实正确上交',
        value: 1
    },
    {
        label: '核实有误退回',
        value: 2
    }
]

interface submitOptions extends Option {
    text: string
}

// 上报类型
export const appearType: Array<submitOptions> = [
    {
        label: '未上报',
        value: 1,
        text: '上报核验材料'
    },
    {
        label: '已上报',
        value: 2,
        text: '上报核验材料'
    },
    {
        label: '已退回',
        value: 3,
        text: '上报核验材料'
    }
]

// 备案管理流程
export const TechnologicalProcess = {
    // 等待确认
    WaitConfirmation: 'treat_confirm',
    // 等待核实
    PendingVerification: 'treat_verify',
    // 等待上交
    WaitDelivery: 'treat_submit',
    // 等待管局审核
    WaitBureauAudit: 'treat_examine',
    // 退回信息处理
    SendBackHandler: 'refund',
    // 审核通过信息
    PassAudit: 'success'
    // 申请注销网站
    // ApplyWriteOffWeb: 103,
    // 申请注销接入
    // ApplyWriteOffSwitchIn: 104,
    // 备案信息总览
    // Overview: 105
}

// 首页  最新公告   备案流程  法律法规  系统帮助
export const homeId = {
    // 最新公告
    newNotice: 3,
    // 备案流程
    Process: 4,
    // 法律法规
    laws: 5,
    // 系统帮助
    systemHelp: 6
}

// 加密算法
export const encryptionAlgorithm: Array<Options> = [
    {
        label: '不进行加密，明文传输',
        value: '0'
    },
    {
        label: 'AES CBC加密算法',
        value: '1'
    }
]

// 哈希算法
export const hashAlgorithm: Array<Options> = [
    {
        label: 'MD5哈希算法',
        value: '0'
    }
]

// 压缩格式
export const compressedFormat = [
    {
        label: 'ZIP压缩格式',
        value: '0'
    }
]

// 数据同步模式
export const dataSynchronizationMode: Array<Options> = [
    {
        label: '自动模式',
        value: '0'
    },
    {
        label: '手工模式',
        value: '1'
    }
]

// 帮助中心链接
export const helpCenterLink: Array<Options> = [
    {
        label: '关闭',
        value: '0'
    },
    {
        label: '开启',
        value: '1'
    }
]

// 加密链接(SSL)
export const encryptedConnection: Array<Options> = [
    {
        label: '否',
        value: '0'
    },
    {
        label: '是',
        value: '1'
    }
]

// 邮件编码
export const postalNumber: Array<Options> = [
    {
        label: '简体中文',
        value: '1'
    },
    {
        label: '国际化编码（utf8）',
        value: '2'
    },
    {
        label: '繁体中文',
        value: '3'
    }
]

//核验模式
export const testCode: Array<Options> = [
    {
        label: '禁用',
        value: '0'
    },
    {
        label: '启用',
        value: '1'
    }
]

//工信部电子核验
export const ministryTest: Array<Options> = [
    {
        label: '禁用',
        value: '0'
    },
    {
        label: '启用',
        value: '1'
    }
]

//电子核验选项
export const attestationTest: Array<Options> = [
    {
        label: '企业认证',
        value: '1'
    },
    {
        label: '身份认证',
        value: '2'
    },
    {
        label: '手机号验证',
        value: '3'
    }
]
//网站负责人核验方式
export const websiteTest: Array<Options> = [
    {
        label: '默认身份证验证',
        value: '1'
    },
    {
        label: '云拓身份认证',
        value: '2'
    }
]

//是否允许从相册选择
export const albumChoose: Array<Options> = [
    {
        label: '否',
        value: '0'
    },
    {
        label: '是',
        value: '1'
    }
]

//核验单模板类型
export const mouleType: Array<Options> = [
    {
        label: '不带备案专用章',
        value: '1'
    },
    {
        label: '带备案专用章',
        value: '2'
    }
]

//指令邮件通知
export const emailNotice: Array<Options> = [
    {
        label: '否',
        value: '0'
    },
    {
        label: '是',
        value: '1'
    }
]

//异地登录开关
export const loginOpen: Array<Options> = [
    {
        label: '关',
        value: '0'
    },
    {
        label: '开',
        value: '1'
    }
]
//验证码显示
export const codeView: Array<Options> = [
    {
        label: '用户登录',
        value: '1'
    },
    {
        label: '用户注册',
        value: '2'
    },
    {
        label: '备案状态查询',
        value: '3'
    }
]

//邮件验证
export const emailCheck: Array<Options> = [
    {
        label: '用户登入',
        value: '1'
    },
    {
        label: '用户注册',
        value: '2'
    }
]

//安全模式
export const safeMode: Array<Options> = [
    {
        label: '关',
        value: '0'
    },
    {
        label: '开',
        value: '1'
    }
]

//邮件提醒
export const emailMess: Array<Options> = [
    {
        label: '备案返回结果',
        value: '1'
    },
    {
        label: '备案提交管局',
        value: '2'
    }
]
//备案状态查询模式

export const statusSelect: Array<Options> = [
    {
        label: '查询本地库',
        value: '1'
    },
    {
        label: '查询工信部',
        value: '2'
    }
]

//业务备案检查

export const filingsCheck: Array<Options> = [
    {
        label: '禁用',
        value: '0'
    },
    {
        label: '启用',
        value: '1'
    }
]

//备案信息填写模式
export const typeInfo = [
    {
        label: '完整模式',
        value: '0'
    },
    {
        label: '简单模式',
        value: '1'
    }
]

//填写完成是否正确
export const isCorrect = [
    {
        label: '等待确认',
        value: '0'
    },
    {
        label: '直接审核',
        value: '1'
    }
]

//网站主办者注册
export const isRegister = [
    {
        label: '启用',
        value: '0'
    },
    {
        label: '禁用',
        value: '1'
    }
]
//网站主办者自动创建
export const isAutocreate = [
    {
        label: '启用',
        value: '0'
    },
    {
        label: '禁用',
        value: '1'
    }
]

//网站接入IP检查
export const isCheckip = [
    {
        label: '启用',
        value: '0'
    },
    {
        label: '禁用',
        value: '1'
    }
]

// 手机归属地核查
export const isMobilecheck = [
    {
        label: '启用',
        value: '0'
    },
    {
        label: '禁用',
        value: '1'
    }
]

//备案手机短信核验
export const isMessagecheck = [
    {
        label: '启用',
        value: '0'
    },
    {
        label: '禁用',
        value: '1'
    }
]

//备案App服务组件
export const isAppserver = [
    {
        label: '启用',
        value: '0'
    },
    {
        label: '禁用',
        value: '1'
    }
]
// 备份日志
export const backupsLog: Array<Options> = [
    {
        label: '否',
        value: '0'
    },
    {
        label: '是',
        value: '1'
    }
]

//指令接口执行
export const isInstruct = [
    {
        label: '否',
        value: '0'
    },
    {
        label: '是',
        value: '1'
    }
]
// 单位性质
export const natureUnit: Array<Options> = [
    { value: 4, label: '企业' },
    { value: 5, label: '个人' },
    { value: 1, label: '国防机构' },
    { value: 2, label: '政府机关' },
    { value: 3, label: '事业单位' },
    { value: 6, label: '社会团体' },
    { value: 9, label: '民办非企业单位' },
    { value: 10, label: '基金会' },
    { value: 11, label: '律师执业机构' },
    { value: 12, label: '外国在华文化中心' },
    { value: 13, label: '群众性团体组织' },
    { value: 14, label: '司法鉴定机构' },
    { value: 15, label: '宗教团体' },
    { value: 16, label: '境外机构' },
    { value: 17, label: '医疗机构' },
    { value: 18, label: '公证机构' },
    { value: 19, label: '集体经济' },
    { value: 20, label: '仲裁机构' }
]
//使用方式
export const useType = [
    {
        label: '静态',
        value: '1'
    },
    {
        label: '动态',
        value: '2'
    },
    {
        label: '未知',
        value: '3'
    }
]

//使用区域
export const useRegion = [
    {
        label: '境内',
        value: '1'
    },
    {
        label: '境外',
        value: '2'
    }
]
//来源单位类型
export const sourceUnitType = [
    {
        label: '非报备单位',
        value: '0'
    },
    {
        label: '报备单位',
        value: '1'
    }
]

//信息平台分类
export const messageCateory = [
    {
        label: '最新公告',
        value: '1'
    },
    {
        label: '备案流程',
        value: '2'
    },
    {
        label: '法律法规',
        value: '3'
    },
    {
        label: '系统帮助',
        value: '4'
    }
]

//查看权限
export const authoritySee = [
    {
        label: '所有用户',
        value: '1'
    },
    {
        label: '备案用户',
        value: '2'
    }
]
//信息状态
export const messageStatus = [
    {
        label: '启用',
        value: '0'
    },
    {
        label: '禁用',
        value: '1'
    }
]

// 选择模版
export const moulesLists = [
    {
        label: '网站主办者注册成功通知',
        value: '1',
        id: 1
    },
    {
        label: '网站主办者重置密码通知',
        value: '2',
        id: 2
    },
    {
        label: 'ISP核实退回信息处理通知',
        value: '3',
        id: 3
    },
    {
        label: '省管局审核退回信息处理通知',
        value: '4',
        id: 4
    },
    {
        label: '省管局对备案信息审核意见通知',
        value: '5',
        id: 5
    },
    {
        label: '应用系统性能状态超过预警值通知',
        value: '6',
        id: 6
    },
    {
        label: '备案信息上交管局通知',
        value: '7',
        id: 7
    }
]

//信息管理分类
export const manageType = [
    {
        label: '最新公告',
        value: '1',
        id: 1
    },
    {
        label: '备案流程',
        value: '2',
        id: 2
    },
    {
        label: '法律法规',
        value: '3',
        id: 3
    },
    {
        label: '系统帮助',
        value: '4',
        id: 4
    }
]

// 新增管理向导分类
export const orangizeLists = [
    {
        label: '备案管理首页',
        value: '1',
        id: 1
    },
    {
        label: '选择备案类型',
        value: '2',
        id: 2
    },
    {
        label: '新增备案信息',
        value: '3',
        id: 3
    },
    {
        label: '等待管局审核',
        value: '4',
        id: 4
    },
    {
        label: '退回信息处理',
        value: '5',
        id: 5
    },
    {
        label: '审核通过信息',
        value: '6',
        id: 6
    },
    {
        label: '申请注销网站',
        value: '3',
        id: 3
    },
    {
        label: '申请注销接入',
        value: '7',
        id: 7
    },
    {
        label: '备案信息总览',
        value: '8',
        id: 8
    },
    {
        label: 'ICP备案查询',
        value: '9',
        id: 9
    },
    {
        label: '备案历史信息',
        value: '10',
        id: 10
    },
    {
        label: '未备案检测结果',
        value: '11',
        id: 11
    },
    {
        label: '未备案处理结果',
        value: '12',
        id: 12
    },
    {
        label: '备案主体黑名单',
        value: '13',
        id: 13
    },
    {
        label: '备案网站黑名称',
        value: '14',
        id: 14
    },
    {
        label: '非法接入黑名单',
        value: '15',
        id: 15
    },
    {
        label: '备案自查管理',
        value: '16',
        id: 16
    },
    {
        label: '备案主体核查',
        value: '17',
        id: 17
    },
    {
        label: '备案接入核查',
        value: '18',
        id: 18
    },
    {
        label: '空壳网站核查',
        value: '19',
        id: 19
    },
    {
        label: '网站存活检测',
        value: '20',
        id: 20
    },
    {
        label: '备案状态查询',
        value: '21',
        id: 21
    },
    {
        label: '管局信息通知',
        value: '22',
        id: 22
    },
    {
        label: 'ICP备案通知',
        value: '23',
        id: 23
    },
    {
        label: '业务资源',
        value: '24',
        id: 24
    },
    {
        label: '网络资源',
        value: '25',
        id: 25
    },
    {
        label: '参数配置',
        value: '26',
        id: 26
    },
    {
        label: '监管指令',
        value: '27',
        id: 27
    },
    {
        label: 'IP报备单位',
        value: '28',
        id: 28
    },
    {
        label: 'IP使用单位',
        value: '29',
        id: 29
    },

    {
        label: 'IP来源备案',
        value: '30',
        id: 30
    },
    {
        label: 'IP分配备案',
        value: '31',
        id: 31
    },
    {
        label: 'IP广播备案',
        value: '32',
        id: 32
    },

    {
        label: 'IP自带备案',
        value: '33',
        id: 33
    },
    {
        label: 'IP全量备案',
        value: '34',
        id: 34
    },
    {
        label: 'IP越界核查结果',
        value: '35',
        id: 35
    },

    {
        label: 'IP冲突核查结果',
        value: '36',
        id: 36
    },
    {
        label: 'IP末报核查结果',
        value: '37',
        id: 37
    },
    {
        label: 'IP属性核查结果',
        value: '38',
        id: 38
    },

    {
        label: 'IP分配验证',
        value: '39',
        id: 39
    },
    {
        label: '备案通讯文件',
        value: '40',
        id: 40
    }
]

//新增用户向导分类
export const userCateory = [
    {
        label: '新增接入信息',
        value: '1',
        id: 1
    },
    {
        label: '备案信息浏览',
        value: '2',
        id: 2
    },
    {
        label: '变更备案主体',
        value: '3',
        id: 3
    },
    {
        label: '变更备案网站',
        value: '4',
        id: 4
    },
    {
        label: '申请注销主体',
        value: '5',
        id: 5
    },
    {
        label: '申请注销网站',
        value: '6',
        id: 6
    },
    {
        label: '申请注销接入',
        value: '7',
        id: 7
    },
    {
        label: '备案历史信息',
        value: '8',
        id: 8
    },
    {
        label: '备案状态查询',
        value: '9',
        id: 9
    },
    {
        label: '账户管理',
        value: '10',
        id: 10
    }
]

// 处置对象类型

export const objectType = [
    {
        label: '域名',
        value: '1'
    }
]

//处置要求

export const disposal_re = [
    {
        label: '锁定域名转移',
        value: '1'
    },
    {
        label: '停止域名解析',
        value: '2'
    },
    {
        label: '其他',
        value: '3'
    }
]

//上报状态
export const report_status = [
    {
        label: '未上报',
        value: '1'
    },
    {
        label: '已上报',
        value: '2'
    },
    {
        label: '全部',
        value: '3'
    }
]

//前置审批与核验图片

export const verification = [
    {
        label: '关闭',
        value: '0'
    },
    {
        label: '启用',
        value: '1'
    }
]

//备案通讯文件
export const Filing_file = [
    {
        label: '关闭',
        value: '0'
    },
    {
        label: '启用',
        value: '1'
    }
]

// 连接模式
export const link_mode = [
    {
        label: '被动模式',
        value: '1'
    },
    {
        label: '主动模式',
        value: '2'
    }
]

// 共用网站材料
export const commonMaterialType = [
    {
        label: '是',
        value: 1
    },
    {
        label: '否',
        value: 0
    }
]

export const commonGroupOptions = [
    {
        label: '分组',
        value: 1
    },
    {
        label: '全部',
        value: 2
    }
]

// 网站类型
export const webType = 1

// App类型
export const appType = 6

// 网站app类型
export const webAppType: Options[] = [
    {
        label: '网站',
        value: webType
    },
    {
        label: 'APP',
        value: appType
    }
]

// 是否提供SDK服务
export const provideSdkServer: Options[] = [
    {
        label: '否',
        value: '0'
    },
    {
        label: '是',
        value: '1'
    }
]

// 默认app信息
export const defaultAppInfo = {
    sdk_service_shop_text: '',
    sdk_service_type_text: [],
    is_sdk_service: '',
    sdk_service_shop_id: '',
    sdk_service_type_id: [],
    app_icon: '',
    platform_info: []
}

// ip处理状态
export const ipHandlerType: Options[] = [
    {
        label: '未处理',
        value: 0
    },
    {
        label: '已处理',
        value: 1
    }
]

// 文件列表执行类型
export const XMLLists: Options[] = [
    {
        label: 'ICP模块文件',
        value: '1'
    },
    {
        label: 'IP模块文件',
        value: '2'
    }
]

// 变更服务类型
export const modifySubjectType: Options[] = [
    {
        label: '否',
        value: 0
    },
    {
        label: '是',
        value: 1
    }
]

// 变更网站类型
export const modifyServiceType: Options[] = [
    {
        label: '否',
        value: 0
    },
    {
        label: '是',
        value: 1
    }
]

export const toBeSubmitted = 3
export const cancellationProgress = 0
// 服务注销状态
export const logoutStateType: Options[] = [
    { label: '全部', value: '' },
    {
        label: '待提交',
        value: toBeSubmitted
    },
    {
        label: '注销中',
        value: cancellationProgress
    },
    {
        label: '已注销',
        value: 1
    },
    {
        label: '注销失败',
        value: 2
    }
]

// 附件核验模式
export const verificationModelType: Options[] = [
    {
        label: '人工核验',
        value: 1
    },
    {
        label: '电子核验',
        value: 2
    }
]

// 备案业务类型
export const approvalStepType: Options[] = [
    // {
    //     label: '未上报',
    //     value: 0
    // },
    {
        label: '待管局审核',
        value: 1
    },
    {
        label: '待短信核验',
        value: 2
    },
    {
        label: '待人工审核',
        value: 3
    }
]

// 审核状态
export const auditStatuType: Options[] = [
    {
        label: '全部',
        value: ''
    },
    {
        label: '待确认',
        value: 'treat_confirm '
    },
    {
        label: '待核实',
        value: 'treat_verify '
    },
    {
        label: '待上交',
        value: 'treat_submit '
    },
    {
        label: '待管局审核',
        value: 'treat_examine '
    },
    {
        label: '待短信核验',
        value: 'check_sms '
    },
    {
        label: '待管局人工审核',
        value: 'manual_review '
    },
    {
        label: '审核通过',
        value: 'success '
    },
    {
        label: '已退回',
        value: 'refund '
    }
]

// 备案完结状态
export const finishedStateType: Options[] = [
    {
        label: '全部',
        value: ''
    },
    {
        label: '未完结',
        value: 0
    },
    {
        label: '已完结',
        value: 1
    }
]

// 解析状态
export const parseStatusType: Options[] = [
    {
        label: '全部',
        value: ''
    },
    {
        label: '未解析',
        value: 0
    },
    {
        label: '已解析',
        value: 1
    }
]

// 解析状态
export const chinaType: Options[] = [
    {
        label: '全部',
        value: ''
    },
    {
        label: '国内',
        value: 0
    },
    {
        label: '境外',
        value: 1
    }
]

// 支付宝小程序
export const alipayMiniPlatform = 1
// 微信h5
export const weixinH5Platform = 2
// 支付宝小程序和微信网页
export const alipayMiniWeixinH5 = 3

export const verificationPlatformType: Options[] = [
    {
        label: '支付宝小程序',
        value: alipayMiniPlatform
    },
    {
        label: '微信网页',
        value: weixinH5Platform
    },
    {
        label: '支付宝小程序和网页',
        value: alipayMiniWeixinH5
    }
]

export const disposeStatusType: Options[] = [
    {
        label: '全部',
        value: ''
    },
    {
        label: '未处理',
        value: 0
    },
    {
        label: '已整改',
        value: 1
    },
    {
        label: '已处理',
        value: 2
    }
]

// 违规内容处理状态
export const illegalContentType: Options[] = [
    {
        label: '全部',
        value: ''
    },
    {
        label: '已忽略',
        value: 1
    },
    {
        label: '已处理',
        value: 2
    },
    {
        label: '待处理',
        value: 0
    }
]

// 违规类型
export const illegalType: Record<number, string> = {
    1: '赌博',
    2: '色情',
    3: '恐怖暴力',
    4: '政治'
}

// 违规内容处理状态文本
export const illegalContentTextType: Record<number, string> = {
    1: '已忽略',
    2: '已处理',
    0: '待处理'
}

// ip备案阶段
export const IpFiligStatus: Record<string, number> = {
    //等待上交
    wait: 0,
    //管局审核
    examine: 1,
    //退回处理
    refund: 2,
    //审核通过
    pass: 3
}

// 申诉原因
export const reasonsAppealType = [
    { value: 1, label: '被申诉方少分配给申诉方IP' },
    { value: 2, label: '被申诉方多分配给申诉方IP' },
    { value: 3, label: '被申诉方超时未报备申诉方分配的IP' },
    { value: 4, label: '被申诉方超时未退还IP，申请强制回收' },
    { value: 5, label: '被申诉方错误回收申诉方的IP' },
    { value: 6, label: '被申诉方来源IP与申诉方冲突，导致申诉方无法报备IP来源' }
]

// 申诉状态
export const appealStatusType = [
    { value: 0, label: '申诉未成立，具体原因查看操作建议' },
    { value: 1, label: '申诉已成立' },
    { value: 2, label: '被申诉方反馈已操作完成，等待申诉方反馈' },
    { value: 3, label: '被申诉方反馈不予处理，等待申诉方反馈' },
    { value: 4, label: '被申诉方超时未反馈，等待申诉方反馈' },
    { value: 5, label: '申诉方已提交结办，申诉关闭' },
    { value: 6, label: '申诉方反馈被申诉方未改正，申诉进入争议阶段' },
    { value: 7, label: '申诉方超时未反馈，申诉进入争议阶段' },
    { value: 99, label: '您的申诉反馈无效，具体原因查看操作建议' }
]

// 申诉来源
export const appealSourceType = [
    { value: '', label: '全部' },
    { value: 1, label: '发起的申诉' },
    { value: 2, label: '收到的申诉' }
]

// 通知事件类型
export const ipNoticeEventType = [
    {
        value: 1,
        label: '上级单位分配IP，需要下级单位报备IP'
    },
    {
        value: 2,
        label: '上级单位回收IP，需要下级单位退还IP'
    },
    {
        value: 3,
        label: '下级主动退还IP，需要上级单位回收IP'
    }
]

// 通知事件进度
export const ipEventProcessType = [
    {
        value: 1,
        label: '等待下级单位操作'
    },
    {
        value: 2,
        label: '等待上级单位操作'
    },
    {
        value: 3,
        label: '因下级单位报备结束事件'
    },
    {
        value: 4,
        label: '因上级单位报备结束事件'
    },
    {
        value: 5,
        label: '下级单位操作超时'
    },
    {
        value: 6,
        label: '上级单位操作超时'
    },
    {
        value: 7,
        label: '计时暂停，等待下级单位的下级操作'
    },
    {
        value: 8,
        label: '计时暂停，等待申诉结果'
    },
    {
        value: 9,
        label: '因上级单位撤销操作结束事件'
    }
]

// 申诉反馈：
export const ipFeedbackType = [
    {
        value: 1,
        label: '被申诉方反馈已改正'
    },
    {
        value: 2,
        label: '被申诉方反馈不予处理'
    },
    {
        value: 3,
        label: '申诉方反馈结办'
    },
    {
        value: 4,
        label: '申诉方反馈被申诉方未改正'
    }
]
